export default __webpack_public_path__ + "images/logo-small-icon.svg";